import React from 'react';
import { useState } from "react";
import { Link } from "react-router-dom";
import { useModal } from '../../contexts/ModalContext';
import BookingPopup from '../../components/BookingPopup';

export default function HomeFaq({ extraClass = "", faqs = [] }) {
  const [showSerachEngine, setshowSerachEngine] = useState(false);

  const [activeIndex, setActiveIndex] = useState(null);
  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <>
      <section className={`home-faq ${extraClass}`}>
        <div className="container">
          <div className="row home-row">
            <div className="col-md-12 col-lg-4">
              <div className="faq-left">
                <h2 className="heading">Our FAQ’s</h2>
                <div className="faq-content">
                  <p>Have a question? Let’s discuss your specific needs.</p>
                  <div className="faq-btn">
                  <Link onClick={() => setshowSerachEngine(true)} className="theme-btn white-btn" > 
                  <span className="color-overlay"></span> <span className="btn-txt">Book Online</span></Link>
                  <Link className="theme-btn white-btn" to="tel:+1 780 230 1359">
                   <span className="color-overlay"></span> 
                   <span className="btn-txt"> Call Us +1 780 230 1359</span>
                  </Link>
                  </div>
                  <div className="faq-link">
                    <ul>
                      <li><Link to={"/prohibited-items/"}>Prohibited items <i className="fa-solid fa-arrow-right"></i>  </Link></li>
                      <li><Link to={"/pricing/"} >Pricing <i className="fa-solid fa-arrow-right"></i> </Link> </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-8">
              <div className="faq-right">
                <div className="freqAskQuertion">
                  {faqs.map((faq, index) => (
                    <div className="item" key={index}>
                      <div className={`faq-title ${activeIndex === index ? "active" : ""}`} onClick={() => toggleFaq(index)} >  {faq.question}    </div>
                      <div className="faq-content-inner" style={{ display: activeIndex === index ? "block" : "none", }}    >
                        <div className="content">
                          {typeof faq.answer === "string" ?
                            <p>{faq.answer}</p>
                            : faq.answer}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>
  )
}
